import { IDynamicTableParams } from "../../components/DynamicTable";
import instance from "../../api";

export const getEmployees = (filters: IDynamicTableParams) => {
    return instance().post("employeeReport/report", filters).then(response => response.data);
};

export const getAvailableColumns = () => {
    return instance().post("employeeReport/availableColumns").then(response => response.data);
};

export const getFilterColumns = () => {
    return instance().post("employeeReport/availableGroupColumns").then(response => response.data);
};